module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_600_DemiBold.804f1b3.woff";